import { render, staticRenderFns } from "./success-bid.vue?vue&type=template&id=06df5eda&scoped=true"
import script from "./success-bid.vue?vue&type=script&lang=js"
export * from "./success-bid.vue?vue&type=script&lang=js"
import style0 from "./success-bid.vue?vue&type=style&index=0&id=06df5eda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06df5eda",
  null
  
)

export default component.exports